"use client";
import { useEffect, useState } from "react";
import { MapProvider } from "react-map-gl/mapbox";
import { useAppStore } from "@/store/app";
import { useDataStore } from "@/store/data";
import { getLocationStateFips, getUrlParams, createParamUrl, updateFavicons } from "@/utils/helpers";
import Controls from "@/components/explorer/Controls";
import Map from "@/components/explorer/Map";
import Profile from "@/components/explorer/Profile";

export default function App() {
	const controls = useAppStore(store => store.controls);
	const setControls = useAppStore(store => store.setControls);
	const selectedLocation = useAppStore(store => store.selectedLocation);
	const setSelectedLocation = useAppStore(store => store.setSelectedLocation);
	const getLocation = useDataStore(store => store.getLocation);
	const fetchLocations = useDataStore(store => store.fetchLocations);
	const extents = useDataStore(store => store.extents);
	const fetchExtents = useDataStore(store => store.fetchExtents);
	const setDataLoading = useDataStore(store => store.setDataLoading);
	const [selectedLocationId, setSelectedLocationId] = useState<string | null>(null);
	const [shouldReadSearchParams, setShouldReadSearchParams] = useState<boolean>(true);

	// Fetch extents from remote source
	useEffect(() => {
		if(!extents) fetchExtents();
	}, [extents]);

	// Read URL paremters on page load
	useEffect(() => {
		if(!shouldReadSearchParams) return;
		const { id, ...newControls } = getUrlParams();
		setControls(newControls);
		setShouldReadSearchParams(false);
		if(id) setSelectedLocationId(id);
	}, [getLocation, setSelectedLocation]);

	// Update URL when controls change
	// useEffect(() => {
	// 	const { view, stat, geo, year } = controls;
	// 	const newUrl = `${window.location.origin}/#/${view}/${stat}/${geo}/${year}`;
	// 	history.replaceState(null, "", newUrl);
	// }, [controls]);
	useEffect(() => {
		const urlParams = { ...controls, id: selectedLocation?.id };
		const url = createParamUrl(urlParams);
		history.replaceState(null, "", url);
	}, [controls, selectedLocation]);

	// Set location from URL param
	useEffect(() => {
		if(!selectedLocationId) return;
		const newSelectedLocation = {
			id: selectedLocationId
		};
		setSelectedLocation(newSelectedLocation);
	}, [selectedLocationId]);

	// Update body attribute and favicon when view control changes
	useEffect(() => {
		updateFavicons(controls.view);
	}, [controls.view]);

	// Fetch data for current geo, pass if search params haven't been read or is currently loading data
	useEffect(() => {
		if(shouldReadSearchParams) return;
		setDataLoading(true);
		if(selectedLocation) {
			const state = getLocationStateFips(selectedLocation.id);
			fetchLocations(controls.geo, state, () => {
				setDataLoading(false);
				if(Object.keys(selectedLocation).length <= 2) {
					const newLocation = getLocation(selectedLocation.id);
					setSelectedLocation(newLocation);
				}
			});
		}
	}, [selectedLocation, shouldReadSearchParams]);

	return (
		<MapProvider>
			<Controls />
			<Map />
			<Profile />
		</MapProvider>
	);
}